import type { AppRoute } from '../routing';
import { getRouteMeta } from '../routing/appRoutes';
import { comingSoonContent, overviewPageContent } from './index';
import type { PageContent } from './types';

export type PageInfoContent = PageContent;

export function getPageInfoContent(route: AppRoute): PageInfoContent | null {
  switch (route) {
    case 'overview':
      return {
        title: overviewPageContent.title,
        subtitle: overviewPageContent.subtitle,
        info: overviewPageContent.info,
      };
    case 'coming-soon':
      return {
        title: comingSoonContent.title,
        subtitle: comingSoonContent.subtitle,
        info: comingSoonContent.info ?? comingSoonContent.subtitle,
      };
    default: {
      const routeMeta = getRouteMeta(route);
      return {
        title: routeMeta.title,
        subtitle: routeMeta.section
          ? `${routeMeta.section} · ${routeMeta.breadcrumb}`
          : routeMeta.breadcrumb,
      };
    }
  }
}
